<template>
  <div class="home-footer" @click="handleRecomment">
    <van-button
      safe-area-inset-bottom
      v-if="btnStatus"
      round
      color="#846FFE"
      block
      >{{ btnVal }}</van-button
    >
    <van-button
      safe-area-inset-bottom
      v-else
      plain
      round
      color="#846FFE"
      block
      >{{ btnVal }}</van-button
    >
  </div>
</template>

<script>
import { commentDetail } from '@/api/searchFoods'
import { mapState } from 'vuex'
export default {
  naem: "HomeFooter",
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      btnStatus: true, // button 样式状态
      btnVal: "评价本周食谱", // 按钮文字
    };
  },
  watch:{
    id(val){
      console.log(val)
      this.getCommentDetail(val)
    }
  },
  computed: {
    ...mapState(["openId"])
  },
  mounted(){
    this.getCommentDetail(this.id)
  },
  methods: {
    // 评论
    handleRecomment() {
      this.$router.push({
        path: "/comment",
        query: {
          id: this.id,
        },
      });
    },
    // 获取食谱评论
    async getCommentDetail(id) {
      const data = {
        recipeId: id,
        openId: this.openId,
      };
      const res = await commentDetail(data);
      if (res.data.code === 200) {
        if (res.data.data === null) {
          this.btnVal = "评价本周食谱";
          this.btnStatus = true;
        } else {
          this.btnVal = "查看评价详情";
          this.btnStatus = false;
        }
      }
    },
  },
};
</script>

<style lang="less" scope>
.home-footer {
  padding: 0.2rem 1rem;
  padding-bottom: constant(safe-area-inset-bottom); /*兼容 IOS<11.2*/
  padding-bottom: env(safe-area-inset-bottom); /*兼容 IOS>11.2*/
  position: fixed !important;
  left: 0;
  bottom: 0;
  width: 100%;
  // height: 1.3rem;
  box-sizing: border-box;
  background-color: #fff;
  .van-button__text {
    margin-left: 0.2rem;
    font-size: 0.3rem;
    letter-spacing: 0.05rem;
    font-weight: 600;
  }
}
</style>